import React from 'react';
import { View } from 'react-native';
import { SearchBar, } from 'design-system/SearchBar';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const strings = {
    placeholder: 'Search',
};
export const ContactsSearch = React.forwardRef(({ style, onChangeSearchTerm, onCancel, placeholder, textInputBgStyles, forSearchHeader, }, refSearchInput) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<View style={[styles.container, style]}>
        <SearchBar onCancel={onCancel} ref={refSearchInput} placeholder={placeholder ?? strings.placeholder} onChangeSearchTerm={onChangeSearchTerm} textFieldBackgroundColor={colors.cards.onLight} textInputBgStyles={textInputBgStyles} forSearchHeader={forSearchHeader}/>
      </View>);
});
const styleSet = createStyleSheets((colors) => ({
    container: {
        margin: 0,
        backgroundColor: colors.background.light,
    },
}));
